export const bgGradient =
  "bg-gradient-to-r from-blue-600 via-sky-500 to-purple-600";
export const buttonGradient = "bg-gradient-to-r from-blue-600 to-purple-600";
export const textGradient =
  "bg-gradient-to-r dark:from-violet-600 dark:via-cyan-400 dark:to-teal-300 from-sky-600 to-purple-600 text-transparent bg-clip-text";
export const vaultCardGradient =
  "bg-gradient-to-r from-primary-100/50 via-[#e5dcfa]/50 to-primary-200/20 dark:bg-gradient-to-b dark:from-white/15 dark:via-white/10 dark:to-white/15";
